import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

function getVideoType(src) {
    if (!src) return '';
    if (src.endsWith('.mp4')) return 'video/mp4';
    if (src.endsWith('.webm')) return 'video/webm';
    if (src.endsWith('.ogg')) return 'video/ogg';
    return '';
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let videoEl = this.el;
        let video = videoEl.getAttribute('data-video');
        let videoMobile = videoEl.getAttribute('data-video-mobile');

        let outputVideo = video ? `<source src="${video}" type="${getVideoType(video)}">` : '';
        let outputVideoMobile = videoMobile ? `<source src="${videoMobile}" type="${getVideoType(videoMobile)}">` : '';

        // detect if mobile and append source tags  
        if (window.innerWidth < window.innerHeight) {
            videoEl.innerHTML = `
                ${outputVideoMobile}
            `;
            if (!outputVideoMobile) {
                videoEl.innerHTML = `
                    ${outputVideo}
                `;
            }
        } else {
            videoEl.innerHTML = `
                ${outputVideo}
            `;
            if (!outputVideo) {
                videoEl.innerHTML = `
                    ${outputVideoMobile}
                `;
            }
        }
        videoEl.play();
    }

    destroy() {
        this.el.innerHTML = '';
    }
}
